import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { IconCollection } from '../../../../components';
import LocationBasedPhoneLink from '../../../../components/LocationBasedPhoneLink/LocationBasedPhoneLink';
import css from './StoreContactAndMoreOptions.module.css';
import truncate from 'lodash/truncate';
import { SUPPORT_EMAIL } from '../../../../util/supportEmail';

const CONTACT_EMAIL = SUPPORT_EMAIL;
const CONTACT_PHONE =
  process.env.REACT_APP_TEAM_PHONE_NUMBER || '1-833-234-RENT';

const StoreContactAndMoreOptions = ({ storeName }) => {
  return (
    <div className={css.lookingCard}>
      <div className={css.textSection}>
        <h2>
          <FormattedMessage
            id="StoreProfilePage.noResultsContact.firstHeading"
            values={{ storeName: truncate(storeName, { length: 30 }) }}
            defaultMessage="Can't find what you're looking for from {storeName}?"
          />
        </h2>
        <p>
          <FormattedMessage
            id="ContactAndMoreOptions.firstParagraph"
            defaultMessage="Tell us what you need — our team will help you track it down fast."
          />
        </p>
      </div>

      <div className={css.buttonSection}>
        <LocationBasedPhoneLink
          className={css.secondaryButton}
          defaultPhoneNumber={CONTACT_PHONE}
        >
          <IconCollection name="phone_icon" />
          <FormattedMessage
            id="ContactAndMoreOptions.callUs"
            defaultMessage="Call:"
          />
        </LocationBasedPhoneLink>

        <a href={`mailto:${CONTACT_EMAIL}`} className={css.primaryButton}>
          <IconCollection name="email_icon" />
          <FormattedMessage
            id="ContactAndMoreOptions.contactSupplyTeam"
            defaultMessage="Contact Our Supply Team"
          />
        </a>
      </div>
    </div>
  );
};

export default StoreContactAndMoreOptions;

